/*
/ 全局静态变量定义
切勿随意修改数组次序，很多地方已下标方式使用
 */

export var page = {
  limit: [20, 40, 60, 80, 100],
  page: 1,
  layout: 'total, sizes, prev, pager, next, jumper'
};

/**
 * 无限极分类type
 * @type {{product: number, attachment: number, menu: number, article: number, operator: number}}
 */
export var categoryType = [
// 1 产品分类，2 附件分类，3 文章分类， 4 设置分类， 5 菜单分类， 6 配置分类， 7 游戏分类
{
  name: '产品分类',
  value: 1,
  shortName: '产品'
}, {
  name: '附件分类',
  value: 2,
  shortName: '附件'
}, {
  name: '文章分类',
  value: 3,
  shortName: '文章'
}, {
  name: '设置分类',
  value: 4,
  shortName: '设置'
}, {
  name: '菜单分类',
  value: 5,
  shortName: '菜单'
}, {
  name: '配置分类',
  value: 6,
  shortName: '配置'
}, {
  name: '游戏分类',
  value: 7,
  shortName: '游戏'
}];
export var roleListStatus = [{
  label: '全部',
  value: ''
}, {
  label: '显示',
  value: 1
}, {
  label: '不显示',
  value: 0
}];
export var showHiddenStatus = [{
  label: '显示',
  value: '‘1’'
}, {
  label: '不显示',
  value: '‘0’'
}];
export var switchStatus = [{
  label: '开启',
  value: 1
}, {
  label: '关闭',
  value: 0
}];
export var deletedOrNormal = [{
  label: '正常',
  value: 0
}, {
  label: '已删除',
  value: 1
}];

/**
 * 暂时弃用
 * @type {*[]}
 */
export var configCategory = [{
  label: '系统',
  value: '0'
}, {
  label: '应用',
  value: '1'
}, {
  label: '支付',
  value: '2'
}, {
  label: '其他',
  value: '3'
}];

/**
 * 时间选择器
 */
export var fromList = {
  title: '选择时间',
  custom: true,
  fromTxt: [{
    text: '全部',
    val: ''
  }, {
    text: '今天',
    val: 'today'
  }, {
    text: '昨天',
    val: 'yesterday'
  }, {
    text: '最近7天',
    val: 'lately7'
  }, {
    text: '最近30天',
    val: 'lately30'
  }, {
    text: '本月',
    val: 'month'
  }, {
    text: '本年',
    val: 'year'
  }]
};

// 统计管理时间选择器
export var timeList = {
  title: '选择时间',
  custom: true,
  fromTxt: [{
    text: '昨天',
    val: ""
  }, {
    text: '最近7天',
    val: 'lately7'
  }, {
    text: '最近30天',
    val: 'lately30'
  }]
};

// 黑名单类型
export var blacklistTypeList = [{
  label: '手机',
  value: 1
}, {
  label: '设备ID',
  value: 2
}, {
  label: '提现卡号',
  value: 3
}];

// 开始状态 字典
export var requestLogTypeTag = [{
  label: '代收',
  value: 1,
  tagType: 'success'
}, {
  label: '代付',
  value: 2,
  tagType: 'danger'
}];

// 开始状态 字典
export var startStateList = [{
  label: '未开始',
  value: 0,
  tagType: 'info'
}, {
  label: '已开始',
  value: 1,
  tagType: 'success'
}, {
  label: '已结束',
  value: 2,
  tagType: 'danger'
}];
export var matkaSpeedTypeList = [{
  label: 'Daily',
  value: 1
}, {
  label: 'Speed',
  value: 2
}, {
  label: 'Fast',
  value: 2
}];

// 开始状态 字典
export var openStateList = [{
  label: '未开奖',
  value: 0,
  tagType: 'info'
}, {
  label: '已开奖',
  value: 1,
  tagType: 'success'
}, {
  label: '开奖中',
  value: 2,
  tagType: 'info'
}];
// 代付计划状态
export var payoutPlanStateList = [{
  label: '未开始',
  value: 0,
  tagType: 'info'
}, {
  label: '执行中',
  value: 1,
  tagType: 'warning'
}, {
  label: '执行完成',
  value: 2,
  tagType: 'success'
}, {
  label: '失败终止',
  value: 3,
  tagType: 'danger'
}];
export var paymentSwitchList = [{
  label: '开启',
  value: 1
}, {
  label: '关闭',
  value: 0
}];

// 分组维度 字典
export var groupClassifyList = [{
  label: '生命周期',
  value: 'lifecycle',
  tagType: 'info'
}];
// 分组维度 字典
export var tacticsTypeList = [{
  label: '默认策略',
  value: 1,
  tagType: 'info'
}, {
  label: '自定义策略',
  value: 2,
  tagType: 'success'
}];
// 策略类型 字典
export var stateList = [{
  label: '启用',
  value: true,
  tagType: 'success'
}, {
  label: '停用',
  value: false,
  tagType: 'info'
}];
// 策略类型 字典
export var limitWithdrawList = [{
  label: '正常',
  value: false,
  tagType: 'success'
}, {
  label: '禁止',
  value: true,
  tagType: 'danger'
}];
// 策略类型 字典
export var stateNumList = [{
  label: '启用',
  value: 1,
  tagType: 'success'
}, {
  label: '停用',
  value: 0,
  tagType: 'info'
}];
// 策略类型 字典
export var riskList = [{
  label: '正常用户',
  value: 0,
  tagType: 'success'
}, {
  label: '疑似风险',
  value: 1,
  tagType: 'warning'
}, {
  label: '风险用户',
  value: 2,
  tagType: 'danger'
}];
// 策略类型 字典
export var checkInTypeList = [{
  label: 'Login Bonus',
  value: 1,
  tagType: 'success'
}, {
  label: 'Free',
  value: 2,
  tagType: 'info'
}, {
  label: 'VIP',
  value: 3,
  tagType: 'success'
}, {
  label: 'Gold',
  value: 4,
  tagType: 'winning'
}];
export var checkInRewordTypeList = [{
  label: 'Lottery',
  value: 1,
  tagType: 'success'
}, {
  label: 'Bonus',
  value: 2,
  tagType: 'info'
}, {
  label: 'Turntable',
  value: 3,
  tagType: 'success'
}, {
  label: 'Lottery + Turntable',
  value: 4,
  tagType: 'winning'
}];
// 标签维度 字典
export var tagClassifyList = [{
  label: '充值',
  value: 'recharge',
  tagType: 'info'
}, {
  label: '提现',
  value: 'withdraw',
  tagType: 'info'
}, {
  label: '投注',
  value: 'bet',
  tagType: 'info'
}, {
  label: '行为',
  value: 'behavior',
  tagType: 'info'
}, {
  label: '中奖',
  value: 'winning',
  tagType: 'info'
}];
// 开始状态 字典
export var paidStateList = [{
  label: '已支付',
  value: true,
  tagType: 'success'
}, {
  label: '未支付',
  value: false,
  tagType: 'info'
}];
// 开始状态 字典
export var withdrawStateList = [{
  label: '审核中',
  value: 0,
  tagType: 'warning'
}, {
  label: '已通过',
  value: 1,
  tagType: 'success'
}, {
  label: '已拒绝',
  value: -1,
  tagType: 'danger'
}];
// 开始状态 字典
export var transferStateList = [{
  label: '待推送',
  value: 0,
  tagType: 'info'
}, {
  label: '转账中',
  value: 1,
  tagType: 'warning'
}, {
  label: '转账成功',
  value: 2,
  tagType: 'success'
}, {
  label: '转账失败',
  value: 3,
  tagType: 'danger'
}];
// 开始状态 字典
export var offlineStateList = [{
  label: '线下包',
  value: true,
  tagType: 'danger'
}, {
  label: '线上包',
  value: false,
  tagType: 'success'
}];
// 开始状态 字典
export var yesNoStateList = [{
  label: '是',
  value: true,
  tagType: 'danger'
}, {
  label: '否',
  value: false,
  tagType: 'success'
}];
export var depositOrderTypeList = [{
  label: 'Deposit',
  value: 1,
  tagType: 'success'
}, {
  label: 'GoldPass',
  value: 2,
  tagType: 'warning'
}, {
  label: 'Turn',
  value: 3,
  tagType: 'danger'
}, {
  label: 'Welcome',
  value: 4,
  tagType: 'danger'
}];
// Cashback状态 字典
export var cashbackStateList = [{
  label: '审核中',
  value: 0,
  tagType: 'info'
}, {
  label: '通过',
  value: 1,
  tagType: 'success'
}, {
  label: '失败',
  value: 2,
  tagType: 'danger'
}];
// 开始状态 字典
export var gameRoundStateList = [{
  label: 'Ing',
  value: 1,
  tagType: 'info'
}, {
  label: 'Lose',
  value: 2,
  tagType: 'danger'
}, {
  label: 'CashOut',
  value: 3,
  tagType: 'success'
}, {
  label: 'Win',
  value: 4,
  tagType: 'success'
}];
export var gameSupplierTransferStateList = [{
  label: '已转入未转出',
  value: 1
}, {
  label: '已转出',
  value: 2
}];
// 屏幕方向 字典
export var screenOrientationList = [{
  label: '竖屏',
  value: true
}, {
  label: '横屏',
  value: false
}];

// App审核类型
export var auditSwitchTypeList = [{
  label: '全部进入审核页',
  value: 0,
  tagType: 'success'
}, {
  label: 'IP国家进主包',
  value: 1,
  tagType: 'danger'
}, {
  label: '全部进入主包',
  value: 2,
  tagType: 'danger'
}];
export var settledList = [{
  label: '已结算',
  value: true,
  tagType: 'success'
}, {
  label: '未结算',
  value: false,
  tagType: 'warning'
}];

// 彩票分类
export var productTypeList = [{
  label: 'Kerala',
  value: 'INDIA_KERALA'
}, {
  label: 'Dear',
  value: 'INDIA_DEAR'
}, {
  label: 'WinGo',
  value: 'WIN_GO'
}, {
  label: 'Scratch',
  value: 'SCRATCH'
}, {
  label: 'Box Lottery',
  value: 'INDIA_BOX_LOTTERY'
}, {
  label: '3D Box Lottery',
  value: 'INDIA_3D_LOTTERY'
}, {
  label: 'Matka',
  value: 'INDIA_MATKA'
}, {
  label: 'Pick3',
  value: 'INDIA_PICK3'
}];
// 彩票分类
export var lotteryDearList = [{
  label: 'Dear 1 PM',
  value: 'INDIA_DEAR_ONE'
}, {
  label: 'Dear 6 PM',
  value: 'INDIA_DEAR_SIX'
}, {
  label: 'Dear 8 PM',
  value: 'INDIA_DEAR_EIGHT'
}];
export var canAddResultLotteryList = [{
  label: 'Kerala',
  value: 'INDIA_KERALA'
}, {
  label: 'Box Lottery',
  value: 'INDIA_BOX_LOTTERY'
}, {
  label: '3D Box Lottery',
  value: 'INDIA_3D_LOTTERY'
}, {
  label: 'Matka',
  value: 'INDIA_MATKA'
}, {
  label: 'Pick3',
  value: 'INDIA_PICK3'
}];
export var channelPackageList = [{
  label: 'Kerala Result Query',
  value: 'com.keralaquery3424.kerala_query'
}, {
  label: 'Kerala Quick Query',
  value: 'com.swxlqs.wphjxhc'
}, {
  label: 'Kerala Query Assistant',
  value: 'com.plowo.pwskfo'
}];
export var channelCodeList = [{
  label: 'OePay',
  value: 'OE_PAY'
}];
export var paymentChannelTypeList = [{
  label: '原生',
  value: 1,
  tagType: 'success'
}, {
  label: '唤醒',
  value: 2,
  tagType: 'warning'
}, {
  label: '混合',
  value: 3,
  tagType: 'warning'
}];
export var advertiseStateList = [{
  label: '上架',
  value: 1,
  tagType: 'success'
}, {
  label: '下架',
  value: 0,
  tagType: 'danger'
}];
export var orgList = [{
  label: 'Kerala Daily Push:1001',
  value: 1001
}];
export var osList = [{
  label: '安卓',
  value: 1,
  tagType: 'success'
}, {
  label: 'IOS',
  value: 2,
  tagType: 'danger'
}];
export var packageChannelStateList = [{
  label: '上架中',
  value: 1,
  tagType: 'success'
}, {
  label: '已下架',
  value: 0,
  tagType: 'danger'
}];
export var advertisePlaceList = [{
  label: '主页',
  value: 1
}, {
  label: '游戏页',
  value: 2
}, {
  label: 'Live页',
  value: 3
}];
export var gameSourceList = [{
  label: 'JILI',
  value: 'JILI_GAME'
}, {
  label: 'EVOLUTION',
  value: 'EVOLUTION_GAME'
}, {
  label: 'PG',
  value: 'PG_GAME'
}, {
  label: 'JDB',
  value: 'JDB_GAME'
}, {
  label: 'SPRIBE',
  value: 'SPRIBE_GAME'
}, {
  label: 'RED TIGER',
  value: 'RED_TIGER_GAME'
}, {
  label: '自研',
  value: 'ORIGINAL_GAME'
}];
export var pageComponentCodeList = [{
  label: '首页',
  value: 'PAGE_HOME'
}, {
  label: 'Game - Game',
  value: 'PAGE_GAME_GAME'
}];
// 福利类型
export var bonusDataTypeList = [{
  label: '日签到',
  value: 1
}, {
  label: '周签到',
  value: 2
}, {
  label: '月签到',
  value: 3
}, {
  label: '升级奖励',
  value: 4
}, {
  label: '红包码',
  value: 5
}, {
  label: 'Cashback',
  value: 6
}, {
  label: '每周 Kerala',
  value: 7
}, {
  label: '每周 Scratch',
  value: 8
}];
// matka期次类型
export var matkaIssueTypeList = [{
  label: 'Close',
  value: 0
}, {
  label: 'Open',
  value: 1
}];
// 订单状态
export var lotteryOrderTypeList = [{
  label: '常规购买',
  value: 1
}, {
  label: '注册赠送',
  value: 2
}, {
  label: 'VIP领取',
  value: 3
}, {
  label: '签到领取',
  value: 4
}];
// 订单状态
export var lotteryStateList = [{
  label: '未开奖',
  value: 0
}, {
  label: '已中奖',
  value: 1,
  tagType: 'success'
}, {
  label: '未中奖',
  value: 2
}];
// 订单状态
export var scratchStateList = [{
  label: '未开奖',
  value: 0,
  tagType: 'info'
}, {
  label: '已中奖',
  value: 1,
  tagType: 'success'
}, {
  label: '未中奖',
  value: 2,
  tagType: 'danger'
}];
// 领取状态
export var claimStateList = [{
  label: '-',
  value: false
}, {
  label: '已领取',
  value: true,
  tagType: 'success'
}];
// 领取状态
export var userWalletTypeList = [{
  label: '用户投注',
  value: 'wallet.log.bet'
}, {
  label: '用户购买',
  value: 'wallet.log.buy'
}, {
  label: '游戏赢钱',
  value: 'wallet.log.win'
}, {
  label: '充值',
  value: 'wallet.log.deposit'
}, {
  label: '提现',
  value: 'wallet.log.withdraw'
}, {
  label: '奖金',
  value: 'wallet.log.bonus'
}, {
  label: '周卡',
  value: 'wallet.log.weekly'
}, {
  label: '系统充值',
  value: 'wallet.log.system'
}, {
  label: '退款',
  value: 'wallet.log.refund'
}];
// 退款状态
export var refundStateList = [{
  label: '未退款',
  value: false,
  tagType: 'info'
}, {
  label: '已退款',
  value: true,
  tagType: 'danger'
}];
// 领取状态
export var turntableClaimStateList = [{
  label: '-',
  value: false
}, {
  label: '已领取',
  value: true,
  tagType: 'success'
}];

/****  Dear 彩票相关  ****/

export var dearProductList = [{
  label: 'Dear 1 PM',
  value: 'INDIA_DEAR_ONE'
}, {
  label: 'Dear 6 PM',
  value: 'INDIA_DEAR_SIX'
}, {
  label: 'Dear 8 PM',
  value: 'INDIA_DEAR_EIGHT'
}];
export var dearOptionTypeList = [{
  label: 'Random',
  value: 0
}, {
  label: 'Lucky',
  value: 1
}];
export var keralaTabTypeList = [{
  label: 'Random pick',
  value: 0
}, {
  label: '12 Same Set',
  value: 1
}, {
  label: 'Loose ticket',
  value: 2
}];
export var winGoTabTypeList = [{
  label: 'Number',
  value: 1
}, {
  label: 'Color',
  value: 2
}];
export var winGoProductList = [{
  label: '1 Minute',
  value: 'WIN_GO_ONE_MIN'
}, {
  label: '3 Minutes',
  value: 'WIN_GO_THREE_MIN'
}, {
  label: '5 Minutes',
  value: 'WIN_GO_FIVE_MIN'
}];
export var ProductType = [{
  label: 'KERALA',
  value: 'INDIA_KERALA'
}, {
  label: 'DEAR',
  value: 'INDIA_DEAR'
}];
export var turntableRewardTypeList = [{
  label: '直接奖励',
  value: 1
}, {
  label: '充值领取',
  value: 2
}];
// 游戏投注状态 1 投注 2 赢 3 输 4 退款 5 结束
export var GameState = [{
  label: '投注',
  value: 1,
  tagType: 'info'
}, {
  label: '赢',
  value: 2,
  tagType: 'success'
}, {
  label: '输',
  value: 3,
  tagType: 'danger'
}, {
  label: '退款',
  value: 4,
  tagType: 'warning'
}];